export enum PublicDevelopmentManagerDetailsParams {
  developmentManagerUuid = "developmentManagerUuid",
}
